module.exports = __webpack_public_path__ + "img/哈士奇钥匙扣-3.4079b0dc.jpg";